export default theme => ({
  dialogContent: {
    paddingTop: 25
  },
})